// Port of api/fuel/app/classes/filter/search/games/rules/query/has_inventory_location.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'has_inventory_location',
	require: function(config, filter, data) {
		if (!config || !config.can || !config.can['view.inventory.location']) return false
		if (!filter.rules || !filter.rules.length) return false
		for (var i = 0; i < filter.rules.length; i++) {
			if (filter.rules[i].type && filter.rules[i].type.replace(/\./g, '_') === 'has_inventory_location') return true
		}
		return false
	},
	match: function(rule, config, filter, data, query) {
		if (rule.logic.value === 'yes') {
			query.where('c.collection_private_location', '<>', '')
		} else if (rule.logic.value === 'no') {
			query.where('c.collection_private_location', '=', '')
		}
	}
})
